import React, { useState } from 'react';
import AppContext, { ModalWindowProps, USER_INTERFACE } from './AppContext';
import { Dimensions, Platform } from 'react-native';
import { dealer } from '../../../WhereToBuy/Interfaces/Interface';
import { usePersistedState } from './hooks/usePersistedState';
import { getDataFromStorage } from './Storage/Storage';
import { OTHER_INFO_FIELDS_PROPS } from '../../../Navigator/Components/Service/Account/Components/interfaces';
import { useInteractionsManager } from './hooks/useInteractionsManager';

export const { Searcher } = require("fast-fuzzy");
// import Searcher   from 'fast-fuzzy'

const SMALL_BREAKPOINT = 1000;
const MEDIUM_BREAKPOINT = 1500;
const BREAKPOINT_HYSTERESIS = 48;

const getViewportDimensions = () => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const viewportWidth = Math.round(
      window.visualViewport?.width ??
      document.documentElement?.clientWidth ??
      window.innerWidth
    );
    const viewportHeight = Math.round(
      window.visualViewport?.height ??
      document.documentElement?.clientHeight ??
      window.innerHeight
    );

    return {
      width: viewportWidth,
      height: viewportHeight,
    };
  }

  return Dimensions.get('window');
};

interface AppProvider {
  children: React.ReactNode
}

const AppProvider: React.FC<AppProvider> = ({ children }) => {

  const { width, height } = getViewportDimensions();

  const [currentHeight, setCurrentHeight] = useState(height);
  const [currentWidth, setCurrentWidth] = useState(width);
  const aspectRatio = height / width;
  const [deviceType, setDeviceType] = useState(Platform.OS)
  const [isIOS, setIsIOS] = useState(deviceType === 'ios');

  const [isWeb, setIsWeb] = useState(deviceType === 'web');

  const refWidth = isWeb ? 1920 : (isIOS ? 390 : 412);
  const refHeight = isWeb ? 1080 : (isIOS ? 844 : 914);

  const [scaleAll, setScaleAll] = useState(
    // 1
    Math.min(currentWidth, refWidth) / refWidth
    // 0.8
    // 2
  );




  const baseRefWidth = isWeb ? 1920 : 390; // Base reference width (default to portrait)
  const baseRefHeight = isWeb ? 1080 : 844; // Base reference height (default to portrait)

  useInteractionsManager({
    func: () => {
    const updateDimensions = () => {
      const { width, height } = getViewportDimensions();
      setCurrentWidth(width);
      setCurrentHeight(height);


      
      // Reference dimensions
      const baseRefWidth = isWeb ? 1920 : 390; // Use 1920px for desktops, 390px for mobile
      const baseRefHeight = isWeb ? 1080 : 844;

      // Determine if the screen is landscape or portrait
      const isLandscape = width > height;
      const refWidth = isLandscape ? baseRefHeight : baseRefWidth;
      const refHeight = isLandscape ? baseRefWidth : baseRefHeight;

      // Calculate scale factor based on width instead of aspect ratio
      let calculatedScale = width / refWidth;

      // Adjust scaling behavior for mid-sized screens
      if (width >= 1000 && width < 1400) {
        calculatedScale *= 1.1; // Slightly increase scaling for 1200px-1400px
      }

      // Set min/max limits to prevent extreme changes
      const minimumScale = 0.95; // Ensure elements are never too small
      const maximumScale = 1.25; // Prevent excessive growth
      calculatedScale = Math.max(minimumScale, Math.min(calculatedScale, maximumScale));

      setScaleAll(calculatedScale);
    };


    // Add event listener
    const subscription = Dimensions.addEventListener('change', updateDimensions);

    // Set initial scale
    updateDimensions();

    // Clean up on unmount
    return () => {
      subscription.remove();
    };
  }, deps: [baseRefWidth, baseRefHeight, isWeb, isIOS]});


  const [ACCESS_TOKEN, setACCESS_TOKEN] = useState(
    window.env.ACCESS_TOKEN
  )
  const [X_API_TOKEN, setX_API_TOKEN] = useState(window.env.API_KEY)

  const [allUnitData, setAllUnitData] = useState<null | AllUnitDeanteData>(null)


  const [USER, setUSER] = usePersistedState<USER_INTERFACE | null>(
    {key: 'USER_CREDS'}
  )

  const [OTHER_INFO_FIELDS, setOTHER_INFO_FIELDS] = usePersistedState<OTHER_INFO_FIELDS_PROPS[] | null>({key: 'OTHER_INFO_FIELDS'})
  

  const [allCollectionsData, setAllCollectionsData] = useState<null | AllCollectionsDeanteData>(null)
  const [variantGroupsData, setVariantGroupsData] = useState<null | AllVariantGroupsData>(null)
  const [color_badges, setColorBadges] = useState<null | AllColorBadgesData>(null)


  const [storedBootstrapData, setStoredBootstrapData] = usePersistedState<null | AllDeanteData>({
    key: 'bootstrapData'
  })

  const [aboutData, setAboutData] = useState<AllDeanteData['about'] | null>(null)
  const [instructionsData, setInstructionsData] = useState<InstallationInstructionsJSON | null>(null)
  const [sortOrderData, setSortOrderData] = useState<string[]>([])

  const [catalog_Types, setCatalogTypes] = useState<catalogTypes[]>([])

  const [dealersList, setDealers] = usePersistedState<dealer[]>({
    key: 'dealersList'
  })

 

  const [portfolioList, setPortfolioList] = usePersistedState<PorfolioList[]>({
    key: 'portfolioList'
  })
 






  const [SearcherUnit, setSearcherUnit] = useState<any | null> (
    null
  )

  const [showDiscountedPrices, setShowDiscountedPrices] = usePersistedState<boolean>({key: 'showDiscountedPrices', 
    initial: getDataFromStorage('showDiscountedPrices') ?? false})


  useInteractionsManager({
    func: () => {
    setSearcherUnit(
      allUnitData ? new Searcher(
        Object.values(allUnitData),
              {keySelector: (obj: DeanteData) => obj.id + obj.art +  + ' ' + obj.col + obj.color1 + obj.color2+ obj.color3+ obj.full_size + obj.name + obj.material + obj.fab},
          ) : null
    )
  }, deps: [allUnitData]})

  const setBootstrapData = React.useCallback((next: AllDeanteData | null) => {
    setStoredBootstrapData(next)
    setAllUnitData(next?.units ?? null)
    setAllCollectionsData(next?.collections ?? null)
    setVariantGroupsData(next?.variant_groups ?? null)
    setColorBadges(next?.color_badges ?? null)
    setAboutData(next?.about ?? null)
    setInstructionsData(next?.instructions ?? null)
    setSortOrderData(next?.sort_order ?? [])
    setCatalogTypes(next?.catalog ?? [])
  }, [setStoredBootstrapData])

  useInteractionsManager({
    func: () => {
    if (storedBootstrapData) {
      setAllUnitData(storedBootstrapData.units ?? null)
      setAllCollectionsData(storedBootstrapData.collections ?? null)
      setVariantGroupsData(storedBootstrapData.variant_groups ?? null)
      setAboutData(storedBootstrapData.about ?? null)
      setInstructionsData(storedBootstrapData.instructions ?? null)
      setSortOrderData(storedBootstrapData.sort_order ?? [])
      setCatalogTypes(storedBootstrapData.catalog ?? [])
      setColorBadges(storedBootstrapData.color_badges ?? null)
    }
  }, deps: [storedBootstrapData]})

  const [ModalWindow, setModalWindow] = useState<ModalWindowProps>({
    enabled: false,
    ModalWindow: null
  })



  const [isSmallVersion, setSmallVersion] = useState(currentWidth < 1000)

  const [isMediumVersion, setMediumVersion] = useState(currentWidth < 1500)

  const [isTooBigVersion, setTooBigVersion] = useState(currentWidth > 1920)

  const [isTooSmall, setIsTooSmall] = useState(currentWidth < 730)
  
  useInteractionsManager({
    func: () => {
    setSmallVersion((prev) =>
      prev
        ? currentWidth <= SMALL_BREAKPOINT + BREAKPOINT_HYSTERESIS
        : currentWidth < SMALL_BREAKPOINT - BREAKPOINT_HYSTERESIS
    )
    setMediumVersion((prev) =>
      prev
        ? currentWidth <= MEDIUM_BREAKPOINT + BREAKPOINT_HYSTERESIS
        : currentWidth < MEDIUM_BREAKPOINT - BREAKPOINT_HYSTERESIS
    )
    setTooBigVersion(currentWidth > 1920)
    setIsTooSmall(currentWidth < 730)
  }, deps: [currentWidth]})

  const [leftSlideOut, setLeftSlideOut] = useState(false)

  const [SearchBarTopActive,setSearchBarTopActive] = useState(false)
  


  const value = React.useMemo(() => ({

      OTHER_INFO_FIELDS, setOTHER_INFO_FIELDS,
      USER, setUSER,
      showDiscountedPrices, setShowDiscountedPrices,
      catalog_Types, setCatalogTypes,
      portfolioList, setPortfolioList,
      isTooSmall, setIsTooSmall,
      dealersList, setDealers,
      SearchBarTopActive,setSearchBarTopActive,
      SearcherUnit, setSearcherUnit,
      isTooBigVersion,
      leftSlideOut, setLeftSlideOut,
      isMediumVersion, setMediumVersion,
      isSmallVersion, setSmallVersion,
      ModalWindow, setModalWindow,
      allUnitData, setAllUnitData,
      allCollectionsData, setAllCollectionsData,
      variantGroupsData, setVariantGroupsData,
      aboutData, setAboutData,
      instructionsData, setInstructionsData,
      sortOrderData, setSortOrderData,
      setBootstrapData,
      color_badges, setColorBadges,
      isIOS, isWeb, currentWidth, currentHeight, refWidth, refHeight, scaleAll, deviceType,
      ACCESS_TOKEN, setACCESS_TOKEN, X_API_TOKEN, setX_API_TOKEN,
    }
  ),[
      OTHER_INFO_FIELDS, setOTHER_INFO_FIELDS,
      USER, setUSER,
      showDiscountedPrices, setShowDiscountedPrices,
      catalog_Types, setCatalogTypes,
      portfolioList, setPortfolioList,
      isTooSmall, setIsTooSmall,
      dealersList, setDealers,
      SearchBarTopActive,setSearchBarTopActive,
      SearcherUnit, setSearcherUnit,
      isTooBigVersion,
      leftSlideOut, setLeftSlideOut,
      isMediumVersion, setMediumVersion,
      isSmallVersion, setSmallVersion,
      ModalWindow, setModalWindow,
      allUnitData, setAllUnitData,
      allCollectionsData, setAllCollectionsData,
      variantGroupsData, setVariantGroupsData,
      aboutData, setAboutData,
      instructionsData, setInstructionsData,
      sortOrderData, setSortOrderData,
      setBootstrapData,
      color_badges, setColorBadges,
      isIOS, isWeb, currentWidth, currentHeight, refWidth, refHeight, scaleAll, deviceType,
      ACCESS_TOKEN, setACCESS_TOKEN, X_API_TOKEN, setX_API_TOKEN,
  ])


  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>)
}

export default AppProvider

export interface AllUnitDeanteData {
  [key: string]: DeanteData
}

export interface AllColorBadgesData {
  [key: string] : {
    link: string
  }
}
export interface AllDeanteData {
  units: AllUnitDeanteData,
  collections: AllCollectionsDeanteData
  variant_groups: AllVariantGroupsData,
  color_badges: AllColorBadgesData,
  catalog: catalogTypes[],
  about: {
    about_text_small: string[],
    about_small_image_address: string
    about_big_sections: any[]
  },
  instructions: InstallationInstructionsJSON,
  sort_order: string[]
}

export interface AllCollectionsDeanteData {
  [key: string]: CollectionsDeanteData
}

export interface VariantGroupMatchEntry {
  ids: Array<string | number>,
  label: string
}

export interface VariantGroupData {
  id: string | number,
  fab: string,
  col: string,
  name: string,
  superType: string,
  height: string,
  width: string,
  thick: string,
  color_match: Record<string, VariantGroupMatchEntry>,
  size_match: Record<string, VariantGroupMatchEntry>,
  variant_match: Record<string, VariantGroupMatchEntry>
}

export interface AllVariantGroupsData {
  [key: string]: VariantGroupData
}

export interface catalogTypes{
  type: string,
  sub_types: string[],
  image: string
}

export interface CollectionsDeanteData {
  collection_name: string,
  "units_ids": (keyof AllUnitDeanteData)[],
  "collection_small_image_slides_small_mmg": string[],
  "collection_full_image_gallery_slides": string[],
  "collection_small_image_gallery_slides_s": string[],
  'link_pdf': string
}

export interface DeanteData {
  "id": string,
  "fab": string,
  'superType': string,
  "col": string,
  "name": string,
  "descriptionUser"?: string | null,
  "country"?: string | null,
  "poverh": string,
  "price": string,
  "height": string,
  "width": string,
  "material": string,
  "type": string,
  prim: string,
  "thick": string,
  "color1": string,
  "color2": string,
  "color3": string,
  pal: string,
  "tema1": string,
  "tema2": string,
  "tema3": string,
  "tema4": string,
  "uri_small": string,
  "uri_full": string,
  'ed': string,
  "var": string,
  "ves": string,
  "vesED": string,
  "pack_m": string,
  "pack_pz": string,
  discount: number,
  discounted_price: number,
  "ostatki": {
    FreeSklad: string,
    VPutiFree: string, 
    ReservSklad: string, 
    VPutiReserv: string,
    FreeSkladMSK: string,
    VPutiFreeMSK: string, 
    ReservSkladMSK: string, 
    VPutiReservMSK: string
  },// string json, need to decode,

  ostatkiPoland: {
    availabilityDate?: string,
    ean?: string,
    id?: "BGA_017M",
    stock?: number
  },
  'art': string,
  full_size: string,
  rect: string,
  relief: string,
  sliders: {
    full: string[],
    medium: string[]
  },
  krat: string[] // id of same goods but different color
}
export interface ResultJSON { [key: string]: any }



export interface PorfolioList {
  "name": string,
  "folder": string,
  "description_small": string,
  "description_full": string,
  "images":string[],
  "videos": string[]
}

// text_instructions.types.ts

export type InstructionsBlock =
  | { type: "heading"; level: 1 | 2 | 3 | 4 | 5 | 6; text: string }
  | { type: "paragraph"; text: string }
  | { type: "list"; style: "bullet" | "numbered"; items: string[] }
  | { type: "warning"; text: string }
  | { type: "note"; text: string }
  | { type: "tip"; text: string };

export type InstructionCategory =
  | "Аксессуары"
  | "Инсталляции"
  | "Смесители"
  | "Керамика";

export interface InstallationPdfDocument {
  title: string;
  category?: InstructionCategory | string; // можно расширять
  url: string;
  language?: string; // "ru" | "en" | ...
}

export interface InstallationPdfSection {
  enabled: boolean;
  description?: string;
  documents: InstallationPdfDocument[];
}

export interface InstallationInstructionsJSON {
  section: "installation_instructions" | string;
  brand: "deante" | string;
  title: string;
  description?: string;

  meta: {
    language: string; // "ru"
    content_type: "structured_text" | string;
    last_updated?: string; // "YYYY-MM-DD"
  };

  // ключи — названия категорий, значения — массив блоков
  sections: Record<InstructionCategory | string, InstructionsBlock[]>;

  // опционально
  pdf_section?: InstallationPdfSection;
}



export interface chunkJSONToArrayOfJSONsProps { json: DefaultJSON, chunkSize: number }

export const chunkJSONToArrayOfJSONs = ({ json, chunkSize }: chunkJSONToArrayOfJSONsProps): DefaultJSON[] => {
  const keys = Object.keys(json);
  const result: { [key: string]: any }[] = [];

  for (let i = 0; i < keys.length; i += chunkSize) {
    const chunk = keys.slice(i, i + chunkSize).reduce((acc, key) => {
      acc[key] = json[key];
      return acc;
    }, {} as { [key: string]: any });

    result.push(chunk);
  }

  return result;
};


export function chunkArray(array: any[], chunkSize: number) {
  return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, index) =>
    array.slice(index * chunkSize, index * chunkSize + chunkSize)
  );
}
